import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/Services/Services.css";
import imgMonthlyBookkeeping from "@/assets/MonthlyBookkeeping.png";
import iconkey1 from "@/assets/icon_key1.png";
import iconkey2 from "@/assets/icon_key2.png";
import iconkey3 from "@/assets/icon_key3.png";

const MonthlyBookkeeping = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner banservices_mbk">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.monthlyBookkeeping.banner.chips}</span>
            <h1>{t.monthlyBookkeeping.banner.title}</h1>
            <p className="text24">
              {t.monthlyBookkeeping.banner.subtitle}
            </p>
            <a className="btn btnbanner" href="/contact">
              {t.monthlyBookkeeping.banner.button}
            </a>
          </div>
        </div>
      </div>

      <div className="container mb150_75 whatincluded">
        <div className="row">
          <div className="col-lg-6">
            <span className="chips">{t.monthlyBookkeeping.included.chips}</span>
            <h2>{t.monthlyBookkeeping.included.title}</h2>
            <p className="text24">
              {t.monthlyBookkeeping.included.subtitle}
            </p>
            <div className="accordion" id="whatincludedaccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded1"
                    aria-expanded="false"
                    aria-controls="whatincluded1"
                  >
                    {t.monthlyBookkeeping.included.sections.accountsPayable.title}
                  </button>
                </h2>
                <div
                  id="whatincluded1"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.monthlyBookkeeping.included.sections.accountsPayable.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded2"
                    aria-expanded="false"
                    aria-controls="whatincluded2"
                  >
                    {t.monthlyBookkeeping.included.sections.reconciliations.title}
                  </button>
                </h2>
                <div
                  id="whatincluded2"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.monthlyBookkeeping.included.sections.reconciliations.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded3"
                    aria-expanded="false"
                    aria-controls="whatincluded3"
                  >
                    {t.monthlyBookkeeping.included.sections.statements.title}
                  </button>
                </h2>
                <div
                  id="whatincluded3"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.monthlyBookkeeping.included.sections.statements.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded4"
                    aria-expanded="true"
                    aria-controls="whatincluded4"
                  >
                    {t.monthlyBookkeeping.included.sections.categorization.title}
                  </button>
                </h2>
                <div
                  id="whatincluded4"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.monthlyBookkeeping.included.sections.categorization.description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className="mobmt30"
              src={imgMonthlyBookkeeping}
              alt="imgMonthlyBookkeeping"
            />
          </div>
        </div>
      </div>

      <div className="key_benefits mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 keybenfttext">
              <span className="chips">{t.monthlyBookkeeping.benefits.chips}</span>
              <h2>{t.monthlyBookkeeping.benefits.title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="keybenftbox keybenftboxactive">
                <img src={iconkey1} alt="iconkey1" />
                <h4>{t.monthlyBookkeeping.benefits.sections.time.title}</h4>
                <p>
                  {t.monthlyBookkeeping.benefits.sections.time.description}
                </p>
                <a className="btn" href="/contact">
                  {t.monthlyBookkeeping.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey2} alt="iconkey2" />
                <h4>{t.monthlyBookkeeping.benefits.sections.compliance.title}</h4>
                <p>
                  {t.monthlyBookkeeping.benefits.sections.compliance.description}
                </p>
                <a className="btn" href="/contact">
                  {t.monthlyBookkeeping.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey3} alt="iconkey3" />
                <h4>{t.monthlyBookkeeping.benefits.sections.visibility.title}</h4>
                <p>
                  {t.monthlyBookkeeping.benefits.sections.visibility.description}
                </p>
                <a className="btn" href="/contact">
                  {t.monthlyBookkeeping.benefits.button}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb150_75 faqs">
        <div className="faqstext">
          <span className="chips">{t.monthlyBookkeeping.faq.chips}</span>
          <h2>{t.monthlyBookkeeping.faq.title}</h2>
        </div>
        <div className="accordion" id="faqsaccordion">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {t.monthlyBookkeeping.faq.questions.data.question}
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.monthlyBookkeeping.faq.questions.data.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                {t.monthlyBookkeeping.faq.questions.system.question}
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.monthlyBookkeeping.faq.questions.system.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                {t.monthlyBookkeeping.faq.questions.commitment.question}
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.monthlyBookkeeping.faq.questions.commitment.answer}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MonthlyBookkeeping;
